export { Spordybde } from './Spordybde';
export { Utmatting } from './Utmatting';
export { Tøyning } from './Tøyning';
export { Telehiv } from './Telehiv';
